const maxWidth = window.matchMedia("(max-width: 700px)");

const videoContainer = document.querySelectorAll(".video-default");

videoContainer.forEach((container) => {
    const video = container.querySelector("video");
    let videos = video.getAttribute("data-videos")
    const source = video.querySelector("source");

    let play = container.querySelector(".play");
    let pause = container.querySelector(".pause");

    let sound = container?.querySelector(".sound");
    let muted = container?.querySelector(".muted");

    let poster = container?.querySelector(".poster");

    let expandContainer = container?.querySelector(".expand-container");
    let expand = container?.querySelector(".expand");

    // Iphone does not support the full-screen api, hiding this for now
    const agent = navigator.userAgent.toLowerCase();
    const isIPhone = agent.indexOf('iphone') !== -1;
    if (isIPhone && expandContainer) expandContainer.style.display = "none";

    function setInitial() {
        play.style.display = "none";
        pause.style.display = "block";
        poster.style.position = "static"

        // remove sound button
        if (sound && muted) {
            muted.style.display = "none";
            sound.style.display = "none";

            if (video.muted) {
                video.muted = true;
                sound.style.display = "none";
                muted.style.display = "block";
            } else {
                sound.style.display = "block";
                muted.style.display = "none";
                video.muted = false;
            }
        }
    }

    video.addEventListener("playing", () => setInitial(), false);
    video.addEventListener("playing", () => {
        play.style.display = "none";
        pause.style.display = "block";
        poster.style.position = 'static'
    })

    if (videos) {
        videos = videos.split(",");

        if (maxWidth.matches) {
            video.pause();
            source.src = videos[0];
            video.load();
        } else {
            video.pause();
            source.src = videos.length > 1 ? videos[1] : videos[0];
            video.load();
        }
    }

    play && play.addEventListener("click", () => {
        play.style.display = "none";
        pause.style.display = "block";
        poster.style.position = 'static'
        video.play();
    });

    pause && pause.addEventListener("click", () => {
        play.style.display = "block";
        pause.style.display = "none";
        poster.style.position = 'relative'
        video.pause();
    });

    expand?.addEventListener("click", () => expandFunction());
    video.addEventListener("dblclick", () => expandFunction())

    sound?.addEventListener("click", () => {
        video.muted = !video.muted;
        sound.style.display = "none";
        muted.style.display = "block";
    });

    muted?.addEventListener("click", () => {
        video.muted = !video.muted;
        sound.style.display = "block";
        muted.style.display = "none";
    });

    const expandFunction = () => {
        if (video.requestFullscreen) {
            video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) {
            video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) {
            video.msRequestFullscreen();
        }
    }
});
